<div class="ui-g-12 donate-title" translate>DONATE.TITLE</div>
<p>
    {{ 'DONATE.EXPLANATION' | translate }}&nbsp;
    <a href="https://www.paypal.com/donate?hosted_button_id=GVQC58TJ3GZ8U" target="_blank" translate>COMMON.HERE</a>.
</p>
<p translate>DONATE.SUPPORT</p>
<br /><br />
<p> 
    {{ 'DONATE.QUESTIONS' | translate }}
    <a href="mailto:keystonekubb@gmail.com">keystonekubb@gmail.com</a>
</p>